import React from "react";
import SportCode from "components/common/SportCode"
import { findArray, isParalympic, CompetitionFromStore } from 'helpers/utils'
import {
  isFinishedStatus,
  isLiveStatus
} from "helpers/status";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck
} from "@fortawesome/free-solid-svg-icons";
import Label from "components/general/Label";
import { useViewport } from 'components/general/useViewPort';
import Flag from "components/presentation/Flag";


const TkwScoreboard = ({ data, status, mirs_discipline }) => {

  const { breakPoint } = useViewport()

  let scoreboard
  let resultStatus = status

  let home = findArray(data?.results?.items, { startSortOrder: [1] });
  let homeNoc = home?.participant?.organisation?.code;
  let homeSeed = '(' + findArray(home?.eventUnitEntries, { eue_code: ['SEED'] }).eue_value + ')'
  let homeResult = home?.resultData;
  let homeWinner = home?.resultWLT;
  let homeColourTeam = findArray(home?.eventUnitEntries, { eue_code: ['UNIFORM', 'COLOUR'] }).eue_value?.toLowerCase();

  let away = findArray(data?.results?.items, { startSortOrder: [2] });
  let awayNoc = away?.participant?.organisation?.code;
  let awaySeed = '(' + findArray(away?.eventUnitEntries, { eue_code: ['SEED'] }).eue_value + ')'
  let awayResult = away?.resultData;
  let awayWinner = away?.resultWLT;
  let awayColourTeam = findArray(away?.eventUnitEntries, { eue_code: ['UNIFORM', 'COLOUR'] }).eue_value?.toLowerCase()

  let r1 = findArray(data?.results?.periods, { p_code: ['R1'] })
  let r2 = findArray(data?.results?.periods, { p_code: ['R2'] })
  let r3 = findArray(data?.results?.periods, { p_code: ['R3'] })

  let currentPeriod = findArray(data?.results?.extendedInfos, { ei_code: ['PERIOD'] }).ei_value

  let officialLabelHomeCheck
  let officialLabelHomeWCon
  let officialLabelAwayCheck
  let officialLabelAwayWCon

  if (isFinishedStatus(resultStatus)) {
    if (homeWinner.includes("W")) {
      officialLabelHomeCheck = <FontAwesomeIcon icon={faCheck} />
      officialLabelHomeWCon = <ResponsiveHeaders mirs_discipline={mirs_discipline} entity='@ResultCode'
        code={findArray(data?.results?.extendedInfos, { ei_code: ['RES_CODE'] }).ei_value} />
    }
    if (awayWinner.includes("W")) {
      officialLabelAwayCheck = <FontAwesomeIcon icon={faCheck} />
      officialLabelAwayWCon = <ResponsiveHeaders mirs_discipline={mirs_discipline} entity='@ResultCode'
        code={findArray(data?.results?.extendedInfos, { ei_code: ['RES_CODE'] }).ei_value} />
    }
  }
  const competition = CompetitionFromStore();

  scoreboard = (
    <>
      <table className="table">
        <thead>
          <tr>
            <th colSpan="3" className="w-50"></th>
            <th scope="col" className="text-center">
              {isParalympic(competition) ? <Label data="HeaderTotalPoints" />
                :
                <Label data='HeaderScore' />}
            </th>
            {currentPeriod === 'R1' && isLiveStatus(resultStatus)
              ? <th scope="col" className=" text-center score-current w-10">
                <ResponsiveHeaders mirs_discipline={mirs_discipline} entity='@Period' code='R1' /></th>
              : <th scope="col" className=" text-center w-10">
                <ResponsiveHeaders mirs_discipline={mirs_discipline} entity='@Period' code='R1' /></th>
            }

            {!isParalympic(competition) || r2 ? currentPeriod === 'R2' && isLiveStatus(resultStatus)
              ? <th scope="col" className=" text-center score-current w-10">
                <ResponsiveHeaders mirs_discipline={mirs_discipline} entity='@Period' code='R2' /></th>
              : <th scope="col" className=" text-center w-10">
                <ResponsiveHeaders mirs_discipline={mirs_discipline} entity='@Period' code='R2' /></th>
              : ""
            }
            {!isParalympic(competition) ? currentPeriod === 'R3' && isLiveStatus(resultStatus)
              ? <th scope="col" className=" text-center score-current w-10">
                <ResponsiveHeaders mirs_discipline={mirs_discipline} entity='@Period' code='R3' /></th>
              : <th scope="col" className=" text-center w-10">
                <ResponsiveHeaders mirs_discipline={mirs_discipline} entity='@Period' code='R3' /></th>
              : ""
            }

          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="text-start">
              <div className={`score-horizontal-uniform score-horizontal-uniform-home ${homeColourTeam ? 'uniform-color-' + homeColourTeam : 'uniform-color-silver'} `}></div>
              <div className='score-horizontal-team score-horizontal-team-home'>
                <div className={`score-horizontal-uniform-small ${homeColourTeam ? 'uniform-color-' + homeColourTeam : 'uniform-color-silver'} `}></div>
                <div className='score-horizontal-noc-flag-name'>
                  <div className='score-horizontal-noc-flag'>
                    <div className='score-horizontal-code-home'>
                      <div className='score-horizontal-code-noc'>{homeNoc}</div>
                    </div>
                    <Flag noc={homeNoc} className='score-horizontal-flag-home' />
                  </div>
                  <div className='score-horizontal-name score-horizontal-name-home d-none d-md-block'><strong>{home?.participant?.name}</strong><sup>{homeSeed}</sup></div>
                  <div className='score-horizontal-name score-horizontal-name-home d-block d-md-none'><strong>{home?.participant?.shortName}</strong><sup>{homeSeed}</sup></div>
                </div>
              </div>
            </td>

            {breakPoint === "sm" || breakPoint === "xs"
              ? <>
                <td>
                  <div className="d-flex align-items-center justify-content-center">
                    {officialLabelHomeCheck}
                  </div>
                  <div className="d-flex align-items-center">
                    <strong>{officialLabelHomeWCon}</strong>
                  </div>
                </td>
                <td>
                  <></>
                </td>
              </>
              : <>
                <td>
                  <div className="d-flex align-items-center">
                    {officialLabelHomeCheck}&nbsp;
                  </div>
                </td>
                <td>
                  <div className="d-flex align-items-center">
                    <strong>{officialLabelHomeWCon}</strong>
                  </div>
                </td>
              </>
            }

            <td className="text-center align-middle" >
              <div className='score-horizontal-result-number'>
                <strong>{homeResult}</strong>
              </div>
            </td>
            {currentPeriod === 'R1' && isLiveStatus(resultStatus)
              ? (currentPeriod === 'R2' || currentPeriod === 'R3') && r1?.home?.periodScore > r1?.away?.periodScore
                ? <td className="text-center align-middle score-current"><strong>{r1?.home?.periodScore}</strong></td>
                : <td className="text-center align-middle score-current">{r1?.home?.periodScore}</td>

              : (currentPeriod === 'R2' || currentPeriod === 'R3') && r1?.home?.periodScore > r1?.away?.periodScore
                ? <td className="text-center align-middle "><strong>{r1?.home?.periodScore}</strong></td>
                : <td className="text-center align-middle">{r1?.home?.periodScore}</td>
            }

            {!isParalympic(competition) || r2 ? currentPeriod === 'R2' && isLiveStatus(resultStatus)
              ? (currentPeriod === 'R3') && r2?.home?.periodScore > r2?.away?.periodScore
                ? <td className="text-center align-middle score-current"><strong>{r2?.home?.periodScore}</strong></td>
                : <td className="text-center align-middle score-current">{r2?.home?.periodScore}</td>

              : (currentPeriod === 'R3') && r2?.home?.periodScore > r2?.away?.periodScore
                ? <td className="text-center align-middle"><strong>{r2?.home?.periodScore}</strong></td>
                : <td className="text-center align-middle">{r2?.home?.periodScore}</td>
              : ""
            }

            {!isParalympic(competition) ? currentPeriod === 'R3' && isLiveStatus(resultStatus)
              ? (currentPeriod === 'R3') && r3?.home?.periodScore > r3?.away?.periodScore
                ? <td className="text-center align-middle  score-current"><strong>{r3?.home?.periodScore}</strong></td>
                : <td className="text-center align-middle  score-current">{r3?.home?.periodScore}</td>

              : (currentPeriod === 'R3' && isFinishedStatus(resultStatus)) && r3?.home?.periodScore > r3?.away?.periodScore
                ? <td className="text-center align-middle"><strong>{r3?.home?.periodScore}</strong></td>
                : <td className="text-center align-middle">{r3?.home?.periodScore}</td>
              : ""

            }


          </tr>

          <tr>
            <td>
              <div className={`score-horizontal-uniform score-vertical-uniform-away ${awayColourTeam ? 'uniform-color-' + awayColourTeam : 'uniform-color-silver'} `}></div>
              <div className='score-horizontal-team score-horizontal-team-home'>
                <div className={`score-horizontal-uniform-small ${awayColourTeam ? 'uniform-color-' + awayColourTeam : 'uniform-color-silver'} `}></div>
                <div className='score-horizontal-noc-flag-name'>
                  <div className='score-horizontal-noc-flag'>
                    <div className='score-horizontal-code-home'>
                      <div className='score-horizontal-code-noc'>{awayNoc}</div>
                    </div>
                    <Flag noc={awayNoc} className='score-horizontal-flag-home' />
                  </div>
                  <div className='score-horizontal-name score-horizontal-name-home d-none d-md-block'><strong>{away?.participant?.name}</strong><sup>{awaySeed}</sup></div>
                  <div className='score-horizontal-name score-horizontal-name-home d-block d-md-none'><strong>{away?.participant?.shortName}</strong><sup>{awaySeed}</sup></div>
                </div>
              </div>
            </td>

            {breakPoint === "sm" || breakPoint === "xs"
              ? <>
                <td>
                  <div className="d-flex align-items-center justify-content-center">
                    {officialLabelAwayCheck}
                  </div>
                  <div className="d-flex align-items-center">
                    <strong>{officialLabelAwayWCon}</strong>
                  </div>
                </td>
                <td>
                  <></>
                </td>
              </>
              : <>
                <td>
                  <div className="d-flex align-items-center">
                    {officialLabelAwayCheck}&nbsp;
                  </div>
                </td>
                <td>
                  <div className="d-flex align-items-center">
                    <strong>{officialLabelAwayWCon}</strong>
                  </div>
                </td>
              </>
            }

            <td className="text-center align-middle" >
              <div className='score-horizontal-result-number'>
                <strong>{awayResult}</strong>
              </div>
            </td>
            {currentPeriod === 'R1' && isLiveStatus(resultStatus)
              ? (currentPeriod === 'R2' || currentPeriod === 'R3') && r1?.away?.periodScore > r1?.home?.periodScore
                ? <td className="text-center align-middle score-current"><strong>{r1?.away?.periodScore}</strong></td>
                : <td className="text-center align-middle score-current">{r1?.away?.periodScore}</td>

              : (currentPeriod === 'R2' || currentPeriod === 'R3') && r1?.away?.periodScore > r1?.home?.periodScore
                ? <td className="text-center align-middle "><strong>{r1?.away?.periodScore}</strong></td>
                : <td className="text-center align-middle">{r1?.away?.periodScore}</td>
            }

            {!isParalympic(competition) || r2 ? currentPeriod === 'R2' && isLiveStatus(resultStatus)
              ? (currentPeriod === 'R3') && r2?.away?.periodScore > r2?.home?.periodScore
                ? <td className="text-center align-middle score-current"><strong>{r2?.away?.periodScore}</strong></td>
                : <td className="text-center align-middle score-current">{r2?.away?.periodScore}</td>

              : (currentPeriod === 'R3') && r2?.away?.periodScore > r2?.home?.periodScore
                ? <td className="text-center align-middle"><strong>{r2?.away?.periodScore}</strong></td>
                : <td className="text-center align-middle">{r2?.away?.periodScore}</td>
              : ""
            }

            {!isParalympic(competition) ? currentPeriod === 'R3' && isLiveStatus(resultStatus)
              ? (currentPeriod === 'R3') && r3?.away?.periodScore > r3?.home?.periodScore
                ? <td className="text-center align-middle  score-current"><strong>{r3?.away?.periodScore}</strong></td>
                : <td className="text-center align-middle  score-current">{r3?.away?.periodScore}</td>

              : (currentPeriod === 'R3' && isFinishedStatus(resultStatus)) && r3?.away?.periodScore > r3?.home?.periodScore
                ? <td className="text-center align-middle"><strong>{r3?.away?.periodScore}</strong></td>
                : <td className="text-center align-middle">{r3?.away?.periodScore}</td>
              : ""
            }

          </tr>
        </tbody>
      </table>
    </>
  )

  return scoreboard
}


const ResponsiveHeaders = ({ mirs_discipline, entity, code }) => {
  const { breakPoint } = useViewport()
  if (breakPoint === "sm" || breakPoint === "xs") {
    return (
      <>{code}</>

    )
  }
  else {
    return (
      <>
        <SportCode discipline={mirs_discipline} entity={entity} code={code} />
      </>
    )
  }

}

export default TkwScoreboard